import { TextField, FormControl, InputLabel, OutlinedInput, InputAdornment, Tooltip } from "@mui/material";
import {useRef, useEffect} from 'react';
export default function FormWip(props) {
    const formatNumber = (num) => {
        if (!num) return '';
        // Remove any existing commas and non-numeric characters except decimal point
        const cleanNum = num.toString().replace(/[^\d.-]/g, '');
        // Format with commas
        return cleanNum.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    const onChange = (e) => {
        const { name, value } = e.target;
        // Remove commas before saving to state
        const cleanValue = value.replace(/,/g, '');
        const finalValue = cleanValue === '' ? 0 : cleanValue;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: finalValue });
    }

    const onChecked = (e) => {
        const { name, checked } = e.target;
        props.setSelectedFinancial({ ...props.selectedFinancial, [name]: checked });
    }
  // Create ref for first input
  const firstInputRef = useRef(null);

  // Focus on first input when component mounts
  useEffect(() => {
      if (firstInputRef.current) {
          firstInputRef.current.focus();
      }
  }, []); // Empty dependency array means this runs once when component mounts

    return (
        <>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="Total dollar value of all project billings divided by total dollar value of all projects shown on the WIP." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Billed Complete on WIP</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">%</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.wipBilled)}
                                onChange={onChange}
                                name='wipBilled'
                                label="Billed Complete on WIP"
                                inputRef={firstInputRef}
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Total dollar value of all project cost to date divided by total dollar value of all projects shown on the WIP." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Cost Complete on WIP</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">%</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.wipCost)}
                                onChange={onChange}
                                name='wipCost'
                                label="Cost Complete on WIP"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">
                    <Tooltip title="Total labor hours to date on all projects divided by total budgeted hours on all projects shown on the WIP." arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Labor Complete on WIP</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">%</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.wipLabor)}
                                onChange={onChange}
                                name='wipLabor'
                                label="Labor Complete on WIP"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
            </div>
            <div className="formRow">
                <div className="formGroup">
                    <Tooltip title="The labor productivity index is calculated as earned hours to date divided by actual hours to date.  Earned hours is obtained by taking (total actual quantities / total estimated quantities) X the total estimated hours.  A value of less than one means you are losing on the labor budget and a value great than one means you are beating the labor budget. " arrow placement="top">
                        <FormControl className="formControl">
                            <InputLabel>Labor Productivity Index</InputLabel>
                            <OutlinedInput
                                startAdornment={<InputAdornment position="start">+/-</InputAdornment>}
                                value={formatNumber(props.selectedFinancial.wipLaborProductivity)}
                                onChange={onChange}
                                name='wipLaborProductivity'
                                label="Labor Productivity Index"
                            />
                        </FormControl>
                    </Tooltip>
                </div>
                <div className="formGroup">

                </div>
                <div className="formGroup">

                </div>
            </div>




        </>
    );
}